import React from 'react';

import { Trans } from 'react-i18next';

import Toast from '../../../../../../shared/components/Globals/Toast/Toast';
import type { IProspect } from '../../../../../../shared/interfaces/prospects';
import type { IQuote } from '../../../../../../shared/interfaces/quotes';
import type { StatusVariant } from '../../../../../../shared/types/globals';
import UnacceptQuoteModal from '../UnacceptQuoteModal/UnacceptQuoteModal';

interface QuoteFeedbackProps {
  prospect: IProspect;
  toast: { open: boolean; message: string; variant: StatusVariant };
  setToast: React.Dispatch<React.SetStateAction<{ open: boolean; message: string; variant: StatusVariant }>>;
  unacceptTarget: IQuote | null;
  onCancelUnaccept: () => void;
  onConfirmUnaccept: (prospectId: number) => void;
}

const QuoteFeedback = ({
  prospect,
  toast,
  setToast,
  unacceptTarget,
  onCancelUnaccept,
  onConfirmUnaccept
}: QuoteFeedbackProps) => {
  return (
    <>
      <Toast
        open={toast.open}
        message={<Trans i18nKey={toast.message} components={{ b: <b /> }} />}
        variant={toast.variant}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      />

      <UnacceptQuoteModal
        open={!!unacceptTarget}
        quoteName={unacceptTarget?.name ?? ''}
        companyName={prospect.companyName}
        onCancel={onCancelUnaccept}
        onConfirm={() => onConfirmUnaccept(prospect.id)}
      />
    </>
  );
};

export default QuoteFeedback;
